import React, { createContext, useContext, useEffect, useState } from "react";

const ViewAsContext = createContext({
  override: null,
  setOverride: () => {},
  isDevMode: false,
});

const STORAGE_KEY = "landit_view_as_override";
const VALID = ["katze", "eule", "biene", "hund"];

export function ViewAsProvider({ children }) {
  const [override, setOverrideState] = useState(() => {
    if (typeof window === "undefined") return null;
    const v = window.localStorage.getItem(STORAGE_KEY);
    return VALID.includes(v) ? v : null;
  });
  const [isDevMode, setIsDevMode] = useState(false);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/env`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => setIsDevMode(!!d?.is_development))
      .catch(() => setIsDevMode(false));
  }, []);

  const setOverride = (slug) => {
    if (slug && VALID.includes(slug)) {
      setOverrideState(slug);
      window.localStorage.setItem(STORAGE_KEY, slug);
    } else {
      setOverrideState(null);
      window.localStorage.removeItem(STORAGE_KEY);
    }
  };

  return (
    <ViewAsContext.Provider value={{ override, setOverride, isDevMode }}>
      {children}
    </ViewAsContext.Provider>
  );
}

export function useViewAs() {
  return useContext(ViewAsContext);
}

// Hilfs-Hook: liefert den effektiven primary_fokustyp (Override hat Vorrang).
export function useEffectivePrimary(user) {
  const { override } = useContext(ViewAsContext);
  return override || user?.primary_fokustyp || null;
}
